import { Col, Row } from "reactstrap";
import { H4 } from "../../../AbstractElements";
import { SearchPixelStrap } from "../../../Constant";
import { SEARCH_TAB_DATA } from "../../../Data/SearchResult";
import SearchBanner from "./SearchBanner";
import InformationCommon from "./common/InformationCommon";
import PagesSort from "./Pages";

const AllTabs = () => {
  return (
    <Row>
      <Col xxl="8" xl="6" className="box-col-7">
        <H4 className="f-w-700 mb-2">{SearchPixelStrap}</H4>
        {SEARCH_TAB_DATA.map((item, i) => (
          <InformationCommon item={item} key={i} />
        ))}
      </Col>
      <SearchBanner />
      <PagesSort pageClass="end" />
    </Row>
  );
};
export default AllTabs;
